import * as api from '../api/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

const namespace = 'CONFERENCE';

export const PREFERENCE_FETCH = createRequestTypes(
  `${namespace}/PREFERENCE_FETCH`,
);
export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH[START],
  PREFERENCE_FETCH[SUCCESS],
  PREFERENCE_FETCH[ERROR],
);

export const PREFERENCE_PERSIST = createRequestTypes(
  `${namespace}/PREFERENCE_PERSIST`,
);
export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST[START],
  PREFERENCE_PERSIST[SUCCESS],
  PREFERENCE_PERSIST[ERROR],
);

export const FETCH_WAITING_ROOM_CONFIG_OPTIONS = createRequestTypes(
  `${namespace}/FETCH_WAITING_ROOM_CONFIG_OPTIONS`,
);

export const fetchWaitingRoomConfigOptions = makeApiActionCreatorV3(
  api.fetchWaitingRoomConfigOptions,
  FETCH_WAITING_ROOM_CONFIG_OPTIONS[START],
  FETCH_WAITING_ROOM_CONFIG_OPTIONS[SUCCESS],
  FETCH_WAITING_ROOM_CONFIG_OPTIONS[ERROR],
);

export const FETCH_WAITING_ROOM_CONFIG = createRequestTypes(
  `${namespace}/FETCH_WAITING_ROOM_CONFIG`,
);

export const fetchWaitingRoomConfig = makeApiActionCreatorV3(
  api.fetchWaitingRoomConfig,
  FETCH_WAITING_ROOM_CONFIG[START],
  FETCH_WAITING_ROOM_CONFIG[SUCCESS],
  FETCH_WAITING_ROOM_CONFIG[ERROR],
);

export const fetchAllWaitingRoomConfig = makeApiActionCreatorV3(
  api.fetchAllWaitingRoomConfig,
  FETCH_WAITING_ROOM_CONFIG[START],
  FETCH_WAITING_ROOM_CONFIG[SUCCESS],
  FETCH_WAITING_ROOM_CONFIG[ERROR],
);

export const CREATE_WAITING_ROOM_CONFIG = createRequestTypes(
  `${namespace}/CREATE_WAITING_ROOM_CONFIG`,
);

export const createWaitingRoomConfig = makeApiActionCreatorV3(
  api.createWaitingRoomConfig,
  CREATE_WAITING_ROOM_CONFIG[START],
  CREATE_WAITING_ROOM_CONFIG[SUCCESS],
  CREATE_WAITING_ROOM_CONFIG[ERROR],
);

export const UPDATE_WAITING_ROOM_CONFIG = createRequestTypes(
  `${namespace}/UPDATE_WAITING_ROOM_CONFIG`,
);

export const updateWaitingRoomConfig = makeApiActionCreatorV3(
  api.updateWaitingRoomConfig,
  UPDATE_WAITING_ROOM_CONFIG[START],
  UPDATE_WAITING_ROOM_CONFIG[SUCCESS],
  UPDATE_WAITING_ROOM_CONFIG[ERROR],
);

export const DELETE_WAITING_ROOM_CONFIG = createRequestTypes(
  `${namespace}/DELETE_WAITING_ROOM_CONFIG`,
);

export const deleteWaitingRoomConfig = makeApiActionCreatorV3(
  api.deleteWaitingRoomConfig,
  DELETE_WAITING_ROOM_CONFIG[START],
  DELETE_WAITING_ROOM_CONFIG[SUCCESS],
  DELETE_WAITING_ROOM_CONFIG[ERROR],
);

export const CLEAR_WAITING_ROOM_RECORDS = `${namespace}/CLEAR_WAITING_ROOM_RECORDS`;

export const clearWaitingRoomRecords = () => ({
  type: CLEAR_WAITING_ROOM_RECORDS,
  payload: [],
});

export const CLEAR_ALL_WAITING_ROOM_RECORDS = `${namespace}/CLEAR_ALL_WAITING_ROOM_RECORDS`;

export const clearAllWaitingRoomRecords = () => ({
  type: CLEAR_ALL_WAITING_ROOM_RECORDS,
  payload: [],
});

export const FETCH_WAITING_ROOM_RECORDS = createRequestTypes(
  `${namespace}/FETCH_WAITING_ROOM_RECORDS`,
);

export const fetchWaitingRoomRecords = makeApiActionCreatorV3(
  api.fetchWaitingRoomRecords,
  FETCH_WAITING_ROOM_RECORDS[START],
  FETCH_WAITING_ROOM_RECORDS[SUCCESS],
  FETCH_WAITING_ROOM_RECORDS[ERROR],
);

export const FETCH_SORT_WAITING_ROOM_RECORDS = createRequestTypes(
  `${namespace}/FETCH_SORT_WAITING_ROOM_RECORDS`,
);

export const fetchSortWaitingRoomRecords = makeApiActionCreatorV3(
  api.fetchSortWaitingRoomRecords,
  FETCH_SORT_WAITING_ROOM_RECORDS[START],
  FETCH_SORT_WAITING_ROOM_RECORDS[SUCCESS],
  FETCH_SORT_WAITING_ROOM_RECORDS[ERROR],
);

export const FETCH_WAITING_ROOM_ALL_RECORDS = createRequestTypes(
  `${namespace}/FETCH_WAITING_ROOM_ALL_RECORDS`,
);

export const fetchWaitingRoomAllRecords = makeApiActionCreatorV3(
  api.fetchWaitingRoomAllRecords,
  FETCH_WAITING_ROOM_ALL_RECORDS[START],
  FETCH_WAITING_ROOM_ALL_RECORDS[SUCCESS],
  FETCH_WAITING_ROOM_ALL_RECORDS[ERROR],
);

export const FETCH_WAITING_ROOM_ALL_RECORDS_BY_TYPE = createRequestTypes(
  `${namespace}/FETCH_WAITING_ROOM_ALL_RECORDS_BY_TYPE`,
);

export const fetchWaitingRoomAllRecordsByType = makeApiActionCreatorV3(
  api.fetchWaitingRoomAllRecordsByType,
  FETCH_WAITING_ROOM_ALL_RECORDS_BY_TYPE[START],
  FETCH_WAITING_ROOM_ALL_RECORDS_BY_TYPE[SUCCESS],
  FETCH_WAITING_ROOM_ALL_RECORDS_BY_TYPE[ERROR],
);

export const MOVE_WAITING_ROOM_RECORD = createRequestTypes(
  `${namespace}/MOVE_WAITING_ROOM_RECORD`,
);

export const moveWaitingRoomRecord = makeApiActionCreatorV3(
  api.moveWaitingRoomRecord,
  MOVE_WAITING_ROOM_RECORD[START],
  MOVE_WAITING_ROOM_RECORD[SUCCESS],
  MOVE_WAITING_ROOM_RECORD[ERROR],
);

export const FETCH_SIMILAR_ROOMS = createRequestTypes(
  `${namespace}/FETCH_SIMILAR_ROOMS`,
);

export const fetchSimilarRooms = makeApiActionCreatorV3(
  api.fetchSimilarRooms,
  FETCH_SIMILAR_ROOMS[START],
  FETCH_SIMILAR_ROOMS[SUCCESS],
  FETCH_SIMILAR_ROOMS[ERROR],
);

export const MOVE_TO_DIFFERENT_ROOM = createRequestTypes(
  `${namespace}/MOVE_TO_DIFFERENT_ROOM`,
);

export const moveToDifferentRoom = makeApiActionCreatorV3(
  api.moveToDifferentRoom,
  MOVE_TO_DIFFERENT_ROOM[START],
  MOVE_TO_DIFFERENT_ROOM[SUCCESS],
  MOVE_TO_DIFFERENT_ROOM[ERROR],
);

export const CREATE_CHECK_IN = createRequestTypes(
  `${namespace}/CREATE_CHECK_IN`,
);

export const createCheckIn = makeApiActionCreatorV3(
  api.createCheckIn,
  CREATE_CHECK_IN[START],
  CREATE_CHECK_IN[SUCCESS],
  CREATE_CHECK_IN[ERROR],
);

export const FETCH_CHECK_IN_PROPERTIES = createRequestTypes(
  `${namespace}/FETCH_CHECK_IN_PROPERTIES`,
);

export const fetchCheckInProperties = makeApiActionCreatorV3(
  api.fetchCheckInProperties,
  FETCH_CHECK_IN_PROPERTIES[START],
  FETCH_CHECK_IN_PROPERTIES[SUCCESS],
  FETCH_CHECK_IN_PROPERTIES[ERROR],
);

export const INSERT_CHECK_IN_PROPERTIES = createRequestTypes(
  `${namespace}/INSERT_CHECK_IN_PROPERTIES`,
);

export const insertCheckInProperty = makeApiActionCreatorV3(
  api.insertCheckInProperty,
  INSERT_CHECK_IN_PROPERTIES[START],
  INSERT_CHECK_IN_PROPERTIES[SUCCESS],
  INSERT_CHECK_IN_PROPERTIES[ERROR],
);

export const INSERT_CHECK_IN_PROPERTY_LIST = createRequestTypes(
  `${namespace}/INSERT_CHECK_IN_PROPERTY_LIST`,
);

export const insertCheckInPropertyList = makeApiActionCreatorV3(
  api.insertCheckInPropertyList,
  INSERT_CHECK_IN_PROPERTY_LIST[START],
  INSERT_CHECK_IN_PROPERTY_LIST[SUCCESS],
  INSERT_CHECK_IN_PROPERTY_LIST[ERROR],
);

export const DELETE_CHECK_IN_PROPERTIES = createRequestTypes(
  `${namespace}/DELETE_CHECK_IN_PROPERTIES`,
);

export const deleteCheckInProperty = makeApiActionCreatorV3(
  api.deleteCheckInProperty,
  DELETE_CHECK_IN_PROPERTIES[START],
  DELETE_CHECK_IN_PROPERTIES[SUCCESS],
  DELETE_CHECK_IN_PROPERTIES[ERROR],
);

export const UNFINALIZED_PROPERTY = createRequestTypes(
  `${namespace}/UNFINALIZED_PROPERTY`,
);

export const unfinalizedProperty = makeApiActionCreatorV3(
  api.unfinalizedProperty,
  UNFINALIZED_PROPERTY[START],
  UNFINALIZED_PROPERTY[SUCCESS],
  UNFINALIZED_PROPERTY[ERROR],
);

export const FINALIZE_CHECK_IN_PROPERTIE = createRequestTypes(
  `${namespace}/FINALIZE_CHECK_IN_PROPERTIE`,
);

export const finalizeCheckInProperty = makeApiActionCreatorV3(
  api.finalizeCheckInProperty,
  FINALIZE_CHECK_IN_PROPERTIE[START],
  FINALIZE_CHECK_IN_PROPERTIE[SUCCESS],
  FINALIZE_CHECK_IN_PROPERTIE[ERROR],
);

export const SET_CHECK_IN_ACTIVE_PROPERTY = createRequestTypes(
  `${namespace}/SET_CHECK_IN_ACTIVE_PROPERTY`,
);

export const setCheckInActiveProperty = makeApiActionCreatorV3(
  api.setCheckInActiveProperty,
  SET_CHECK_IN_ACTIVE_PROPERTY[START],
  SET_CHECK_IN_ACTIVE_PROPERTY[SUCCESS],
  SET_CHECK_IN_ACTIVE_PROPERTY[ERROR],
);

export const VALID_CHECK_IN_PROPERTIES = createRequestTypes(
  `${namespace}/VALID_CHECK_IN_PROPERTIES`,
);

export const validCheckInProperty = makeApiActionCreatorV3(
  api.validCheckInProperty,
  VALID_CHECK_IN_PROPERTIES[START],
  VALID_CHECK_IN_PROPERTIES[SUCCESS],
  VALID_CHECK_IN_PROPERTIES[ERROR],
);

export const VALID_CHECK_IN_PROPERTY_ID = createRequestTypes(
  `${namespace}/VALID_CHECK_IN_PROPERTY_ID`,
);

export const validCheckInPropertyID = makeApiActionCreatorV3(
  api.validCheckInPropertyID,
  VALID_CHECK_IN_PROPERTY_ID[START],
  VALID_CHECK_IN_PROPERTY_ID[SUCCESS],
  VALID_CHECK_IN_PROPERTY_ID[ERROR],
);

export const VALIDATE_CHECK_IN = createRequestTypes(
  `${namespace}/VALIDATE_CHECK_IN`,
);

export const validateCheckIn = makeApiActionCreatorV3(
  api.validateCheckIn,
  VALIDATE_CHECK_IN[START],
  VALIDATE_CHECK_IN[SUCCESS],
  VALIDATE_CHECK_IN[ERROR],
);

export const FETCH_CHECK_IN_RECORD = createRequestTypes(
  `${namespace}/FETCH_CHECK_IN_RECORD`,
);

export const fetchCheckInRecord = makeApiActionCreatorV3(
  api.fetchCheckInRecord,
  FETCH_CHECK_IN_RECORD[START],
  FETCH_CHECK_IN_RECORD[SUCCESS],
  FETCH_CHECK_IN_RECORD[ERROR],
);

export const UPDATE_CHECK_IN_RECORD = createRequestTypes(
  `${namespace}/UPDATE_CHECK_IN_RECORD`,
);

export const updateCheckInRecord = makeApiActionCreatorV3(
  api.updateCheckInRecord,
  UPDATE_CHECK_IN_RECORD[START],
  UPDATE_CHECK_IN_RECORD[SUCCESS],
  UPDATE_CHECK_IN_RECORD[ERROR],
);

export const FETCH_MESSAGE_HISTORY = createRequestTypes(
  `${namespace}/FETCH_MESSAGE_HISTORY`,
);

export const fetchMessageHistory = makeApiActionCreatorV3(
  api.fetchMessageHistory,
  FETCH_MESSAGE_HISTORY[START],
  FETCH_MESSAGE_HISTORY[SUCCESS],
  FETCH_MESSAGE_HISTORY[ERROR],
);

export const FETCH_REVISION_HISTORY = createRequestTypes(
  `${namespace}/FETCH_REVISION_HISTORY`,
);

export const fetchRevisionHistory = makeApiActionCreatorV3(
  api.fetchRevisionHistory,
  FETCH_REVISION_HISTORY[START],
  FETCH_REVISION_HISTORY[SUCCESS],
  FETCH_REVISION_HISTORY[ERROR],
);

export const DIRECT_ASSIGNMENT_FROM_WAITING_ROOM = createRequestTypes(
  `${namespace}/DIRECT_ASSIGNMENT_FROM_WAITING_ROOM`,
);

export const directAssignmentFromWaitingRoom = makeApiActionCreatorV3(
  api.directAssignmentFromWaitingRoom,
  DIRECT_ASSIGNMENT_FROM_WAITING_ROOM[START],
  DIRECT_ASSIGNMENT_FROM_WAITING_ROOM[SUCCESS],
  DIRECT_ASSIGNMENT_FROM_WAITING_ROOM[ERROR],
);

export const FETCH_CHECK_IN_PROPERTY_APPEAL = createRequestTypes(
  `${namespace}/FETCH_CHECK_IN_PROPERTY_APPEAL`,
);

export const fetchCheckInPropertyAppeal = makeApiActionCreatorV3(
  api.fetchCheckInPropertyAppeal,
  FETCH_CHECK_IN_PROPERTY_APPEAL[START],
  FETCH_CHECK_IN_PROPERTY_APPEAL[SUCCESS],
  FETCH_CHECK_IN_PROPERTY_APPEAL[ERROR],
);

export const FETCH_CHECK_IN_PROPERTY_APPEAL_INFORMAL = createRequestTypes(
  `${namespace}/FETCH_CHECK_IN_PROPERTY_APPEAL_INFORMAL`,
);

export const fetchCheckInPropertyAppealInformal = makeApiActionCreatorV3(
  api.fetchCheckInPropertyAppealInformal,
  FETCH_CHECK_IN_PROPERTY_APPEAL_INFORMAL[START],
  FETCH_CHECK_IN_PROPERTY_APPEAL_INFORMAL[SUCCESS],
  FETCH_CHECK_IN_PROPERTY_APPEAL_INFORMAL[ERROR],
);

export const UPDATE_CHECK_IN_PROPERTY_APPEAL = createRequestTypes(
  `${namespace}/UPDATE_CHECK_IN_PROPERTY_APPEAL`,
);

export const updateCheckInPropertyAppeal = makeApiActionCreatorV3(
  api.updateCheckInPropertyAppeal,
  UPDATE_CHECK_IN_PROPERTY_APPEAL[START],
  UPDATE_CHECK_IN_PROPERTY_APPEAL[SUCCESS],
  UPDATE_CHECK_IN_PROPERTY_APPEAL[ERROR],
);

export const UPDATE_CHECK_IN_PROPERTY_APPEAL_INFORMAL = createRequestTypes(
  `${namespace}/UPDATE_CHECK_IN_PROPERTY_APPEAL_INFORMAL`,
);

export const updateCheckInPropertyAppealInformal = makeApiActionCreatorV3(
  api.updateCheckInPropertyAppealInformal,
  UPDATE_CHECK_IN_PROPERTY_APPEAL_INFORMAL[START],
  UPDATE_CHECK_IN_PROPERTY_APPEAL_INFORMAL[SUCCESS],
  UPDATE_CHECK_IN_PROPERTY_APPEAL_INFORMAL[ERROR],
);

export const MOVE_PROPERTY_NEW_CHECK_IN = createRequestTypes(
  `${namespace}/MOVE_PROPERTY_NEW_CHECK_IN`,
);

export const movePropertyNewCheckIn = makeApiActionCreatorV3(
  api.movePropertyNewCheckIn,
  MOVE_PROPERTY_NEW_CHECK_IN[START],
  MOVE_PROPERTY_NEW_CHECK_IN[SUCCESS],
  MOVE_PROPERTY_NEW_CHECK_IN[ERROR],
);

export const MOVE_PROPERTY_EXISTING_CHECK_IN = createRequestTypes(
  `${namespace}/MOVE_PROPERTY_EXISTING_CHECK_IN`,
);

export const movePropertyToExistingCheckIn = makeApiActionCreatorV3(
  api.movePropertyToExistingCheckIn,
  MOVE_PROPERTY_EXISTING_CHECK_IN[START],
  MOVE_PROPERTY_EXISTING_CHECK_IN[SUCCESS],
  MOVE_PROPERTY_EXISTING_CHECK_IN[ERROR],
);

export const FINALIZE_WAITING_ROOM_RECORD = createRequestTypes(
  `${namespace}/FINALIZE_WAITING_ROOM_RECORD`,
);

export const finalizeWaitingRoomRecord = makeApiActionCreatorV3(
  api.finalizeWaitingRoomRecord,
  FINALIZE_WAITING_ROOM_RECORD[START],
  FINALIZE_WAITING_ROOM_RECORD[SUCCESS],
  FINALIZE_WAITING_ROOM_RECORD[ERROR],
);

export const SET_POSITIONAL_EXCLUSION = createRequestTypes(
  `${namespace}/SET_POSITIONAL_EXCLUSION`,
);

export const setPositionalExclusion = makeApiActionCreatorV3(
  api.setPositionalExclusion,
  SET_POSITIONAL_EXCLUSION[START],
  SET_POSITIONAL_EXCLUSION[SUCCESS],
  SET_POSITIONAL_EXCLUSION[ERROR],
);

export const CLEAR_POSITIONAL_EXCLUSION = createRequestTypes(
  `${namespace}/CLEAR_POSITIONAL_EXCLUSION`,
);

export const clearPositionalExclusion = makeApiActionCreatorV3(
  api.clearPositionalExclusion,
  CLEAR_POSITIONAL_EXCLUSION[START],
  CLEAR_POSITIONAL_EXCLUSION[SUCCESS],
  CLEAR_POSITIONAL_EXCLUSION[ERROR],
);

export const SET_SELECTED_WAITING_ROOM = `${namespace}/SET_SELECTED_WAITING_ROOM`;

export const setSelectedWaitingRoom = room => ({
  type: SET_SELECTED_WAITING_ROOM,
  payload: room,
});

export const REOPEN_CHECK_IN = createRequestTypes(
  `${namespace}/REOPEN_CHECK_IN`,
);

export const reopenCheckIn = makeApiActionCreatorV3(
  api.reopenCheckIn,
  REOPEN_CHECK_IN[START],
  REOPEN_CHECK_IN[SUCCESS],
  REOPEN_CHECK_IN[ERROR],
);

export const MOVE_CHECKIN_TO_DIFFERNT_ROOM = createRequestTypes(
  `${namespace}/MOVE_CHECKIN_TO_DIFFERNT_ROOM`,
);

export const moveCheckInToDifferentRoom = makeApiActionCreatorV3(
  api.moveCheckInToDifferentRoom,
  MOVE_CHECKIN_TO_DIFFERNT_ROOM[START],
  MOVE_CHECKIN_TO_DIFFERNT_ROOM[SUCCESS],
  MOVE_CHECKIN_TO_DIFFERNT_ROOM[ERROR],
);